import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/sections/Footer';
import { SEO } from '@/components/SEO';
import { LegalDocument } from '@/components/LegalDocument';
import { useTranslation } from 'react-i18next';

const CookiePolicy = () => {
  const { t } = useTranslation('seo');

  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title={t('cookiePolicy.title')}
        description={t('cookiePolicy.description')}
        keywords={t('cookiePolicy.keywords')}
        logicalPath="/cookie-policy"
      />
      <Header />
      <section className="py-16 px-6 md:py-24">
        <div className="mx-auto max-w-4xl">
          <LegalDocument namespace="cookiePolicy" />
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default CookiePolicy;
